// extracted by mini-css-extract-plugin
export default {"icon":"ContentIcon_icon__koNmS"};